export default function Mandala({ className = "" }) {
  const ticks = Array.from({ length: 36 });
  return (
    <svg viewBox="0 0 400 400" className={className} fill="none" aria-hidden="true">
      <circle cx="200" cy="200" r="192" stroke="currentColor" strokeOpacity="0.22" strokeDasharray="2 7" />
      <circle cx="200" cy="200" r="160" stroke="currentColor" strokeOpacity="0.3" strokeDasharray="1 9" />
      <circle cx="200" cy="200" r="120" stroke="currentColor" strokeOpacity="0.28" />
      <circle cx="200" cy="200" r="80" stroke="currentColor" strokeOpacity="0.34" strokeDasharray="2 5" />
      <circle cx="200" cy="200" r="42" stroke="currentColor" strokeOpacity="0.4" />
      {ticks.map((_, i) => {
        const a = (i * 10 * Math.PI) / 180;
        const x1 = 200 + 132 * Math.cos(a);
        const y1 = 200 + 132 * Math.sin(a);
        const x2 = 200 + 152 * Math.cos(a);
        const y2 = 200 + 152 * Math.sin(a);
        return (
          <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="currentColor" strokeOpacity="0.35" strokeWidth="1" />
        );
      })}
      {ticks.map((_, i) => {
        const a = ((i * 10 + 5) * Math.PI) / 180;
        const x = 200 + 96 * Math.cos(a);
        const y = 200 + 96 * Math.sin(a);
        return <circle key={`d${i}`} cx={x} cy={y} r="1.6" fill="currentColor" fillOpacity="0.5" />;
      })}
    </svg>
  );
}
